import { useEffect, useState } from "react";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";
import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Checkbox,
  Chip as MuiChip,
  Divider as MuiDivider,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
} from "@mui/material";
import { green, orange, red } from "@mui/material/colors";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import { spacing } from "@mui/system";
import useDataUser from "hooks/useDataUser";
import UserEditBtn from "./UserEditBtn";
import UserDeleteBtn from "./UserDeleteBtn";
import DownloadUserProgBtn from "./DownloadUserProgBtn";
import DownloadUserPointsBtn from "./DownloadUserPointsBtn";
import SearchUsersByKw from "./SearchUsersByKw";
// ----------------------------------------------------------------------
const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Chip = styled(MuiChip)`
  ${spacing};

  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => ({
    el,
    index,
  }));
  stabilizedThis.sort((a, b) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  });
  return stabilizedThis.map((element) => element.el);
}
const headCells = [
  { id: "id", alignment: "left", label: "ID" },
  { id: "pseudo", alignment: "left", label: "Pseudo" },
  { id: "email", alignment: "left", label: "Email" },
  { id: "status", alignment: "left", label: "Statut" },
  { id: "actions", alignment: "right", label: "Actions" },
];

const EnhancedTableHead = (props) => {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const { numSelected, handleReset, handleSearch } = props;

  return (
    <Toolbar>
      <ToolbarTitle>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} sélectionné(s)
          </Typography>
        ) : (
          <Typography
            variant="h6"
            id="tableTitle"
            style={{ minWidth: "200px" }}
          >
            Tous les utilisateurs
          </Typography>
        )}
      </ToolbarTitle>
      <Spacer />
      <Spacer />
      <div>
        <SearchUsersByKw
          filters={props.filters}
          setfilters={props.setfilters}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>
    </Toolbar>
  );
};
export default function UsersGrid() {
  const { users } = useDataUser();
  const [rows, setrows] = useState([]);
  const [filters, setfilters] = useState({ keywords: "", refstatus: "" });

  useEffect(() => {
    if (!users || !Array.isArray(users)) {
      setrows([]);
      return;
    }
    //setrows(users);
    handleSearch(filters);
  }, [users, filters]);

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  /** search functions */
  const handleSearch = (filters) => {
    try {
      if (!Array.isArray(users)) return;
      // find by keywords of filters and if filters has fields with values, filter by them
      if (!filters) return;

      const { keywords } = filters;
      const filtersActivated = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (key !== "keywords" && value && value.length > 0) {
          filtersActivated[key] = value;
        }
      });

      if (!keywords && Object.keys(filtersActivated).length === 0) {
        handleReset();
        return;
      }
      const newArr = users.filter((it) => {
        const isPseudoContainsKw = it.pseudo
          .toUpperCase()
          .includes(keywords.toUpperCase());
        const isEmailContainsKw = it.email
          .toUpperCase()
          .includes(keywords.toUpperCase());
        const isIdContainsKw = String(it.id)
          .toLocaleUpperCase()
          .includes(keywords.toLocaleUpperCase());
        //browser filtersActivated and check if all filtersActivated are matching with it
        const isFiltersContains = checkFilteredMatches(it, filtersActivated);
        return (
          (isPseudoContainsKw || isEmailContainsKw || isIdContainsKw) &&
          isFiltersContains
        );
      });
      setrows(newArr);
    } catch (error) {
      console.error(error);
    }
  };

  const checkFilteredMatches = (user, filtersActivated) => {
    const fields = Object.entries(filtersActivated);
    for (let i = 0; i < fields.length; i++) {
      const [key, value] = fields[i];

      const objUser = user[key];
      if (!objUser) return false;
      if (typeof objUser === "object" && objUser !== null) {
        if (String(objUser.id) !== String(value)) return false;
      } else if (String(objUser) !== String(value)) return false;
    }
    return true;
  };

  const handleReset = () => {
    try {
      setrows(users);
    } catch (error) {
      console.error(error);
    }
  };
  /** end */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  if (!rows || !Array.isArray(rows)) return <></>;
  return (
    <div>
      <Paper>
        <EnhancedTableToolbar
          numSelected={selected.length}
          handleReset={handleReset}
          handleSearch={handleSearch}
          filters={filters}
          setfilters={setfilters}
        />
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.id}-${index}`}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          onClick={(event) => handleClick(event, row.id)}
                        />
                      </TableCell>

                      <TableCell align="left">#{row.id}</TableCell>
                      <TableCell align="left">
                        {row.pseudo ? row.pseudo : ""}
                      </TableCell>
                      <TableCell align="left">{row.email}</TableCell>
                      <TableCell>
                        {row.enable ? (
                          <Chip
                            size="small"
                            mr={1}
                            mb={1}
                            label="Activé"
                            shipped={+true}
                          />
                        ) : (
                          <Chip
                            size="small"
                            mr={1}
                            mb={1}
                            label="Désactivé"
                            cancelled={+true}
                          />
                        )}
                      </TableCell>
                      <TableCell padding="none" align="right">
                        <Box
                          mr={2}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <DownloadUserPointsBtn idUser={row.id} />
                          <DownloadUserProgBtn idUser={row.id} />
                          <UserEditBtn editUser={row} />
                          <IconButton
                            component={NavLink}
                            to={`/app/user-edit/${row.id}`}
                            aria-label="details"
                            size="large"
                            title="Voir le profile"
                          >
                            <ManageHistoryIcon />
                          </IconButton>
                          <UserDeleteBtn editUser={row} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
